import { render, staticRenderFns } from "./Basket.vue?vue&type=template&id=1f8c1a92&scoped=true&"
import script from "./Basket.vue?vue&type=script&lang=js&"
export * from "./Basket.vue?vue&type=script&lang=js&"
import style0 from "./Basket.vue?vue&type=style&index=0&id=1f8c1a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8c1a92",
  null
  
)

export default component.exports